import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Dashboard from "../components/pages/dashboard";

function ConditionalRouter() {

    return <>
        <Route exact path="/" component={Dashboard} />
    </>
}

function Routers() {
    return (
        <>
            <Router>
                <Switch>
                    <ConditionalRouter />
                </Switch>
            </Router>
        </>
    )
}

export default Routers
